import Spinner from "@/Icons/Spinner";
import { cx } from "@/utils";

import styles from "./Spinner.module.css";

type SpinnerAnimatedProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const SpinnerAnimated: React.FC<SpinnerAnimatedProps> = ({
  className,
  ...props
}) => (
  <Spinner {...props} className={cx("w-10 h-10", styles.root, className)} />
);

export default SpinnerAnimated;
